<!-- MOLECULE: DrawerItem.vue -->
<!-- Navigation drawer list item with active-state highlight, tooltip, and external link support. -->

<script setup lang="ts">
//
// Props & Emits
//
const props = withDefaults(
  defineProps<{
    to: string;
    icon: string;
    title: string;
    tooltipText?: string;
    external?: boolean;
  }>(),
  {
    tooltipText: "",
    external: false,
  },
);

//
// Composables
//

// Drawer
const { isPathActive } = useDrawer();

//
// Computed
//

// Check if the drawer item is active based on the current route
const isActive = computed(() => isPathActive(props.to));
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props: tooltipProps }">
      <v-list-item
        v-bind="tooltipProps"
        :to="!external ? to : undefined"
        :href="external ? to : undefined"
        :target="external ? '_blank' : undefined"
        :rounded="true"
        :active="isActive"
        :class="{ 'text-white': isActive }"
        :prepend-icon="icon"
        :title="title"
        :style="{
          backgroundColor: isActive ? '#264a7a' : undefined,
        }"
      >
      </v-list-item>
    </template>

    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
